import { Box, Typography } from '@mui/material';
import React from 'react';

import { SUPPORT_PHONE_DISPLAY, SUPPORT_PHONE_TEL } from '../../../utils/constants';
import { WizardNavigation } from '../WizardNavigation';

/**
 * GuideErrorStep - Generic error fallback screen
 * 
 * Displayed when an unexpected error occurs in the installation guide.
 * Provides options to try again or contact support.
 */
export const GuideErrorStep: React.FC = () => {
  const handleTryAgain = () => {
    // Reload the page to try again
    window.location.reload();
  };

  const handleCallSupport = () => {
    window.open(SUPPORT_PHONE_TEL);
  };

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        p: 3,
      }}
    >
      <Typography variant="h3" component="h1" sx={{ mb: 2 }}>
        {__('Something went wrong')}
      </Typography>

      <Typography variant="h6" sx={{ mb: 3, color: 'text.secondary' }}>
        {__('We encountered an unexpected error while loading the installation guide.')}
      </Typography>

      <Typography variant="body1" sx={{ mb: 4 }}>
        {__('Please try again. If the problem continues, contact our support team for assistance.')}
      </Typography>

      <WizardNavigation
        primaryLabel={__('Try Again')}
        onPrimary={handleTryAgain}
        secondaryLabel={`${__('Call Support')}: ${SUPPORT_PHONE_DISPLAY}`}
        onSecondary={handleCallSupport}
      />
    </Box>
  );
};
